/**
 * Flag local das telas do núcleo financeiro (docs/finance-core). Elas ficam
 * atrás de flag até a conversão do `main` e o corte do fechamento do deal.
 * Sem backend nem cookie: uma chave no localStorage, ligada uma vez por
 * `?ff=finance-core` na URL.
 */
import { FINANCE_CORE_FLAG } from '../../shared/lib/financeCoreLink.js'

const FLAG_KEY = 'idf:ff:finance-core-ui'

function readStoredFlag(): boolean {
  try {
    return localStorage.getItem(FLAG_KEY) === 'true'
  } catch {
    return false
  }
}

function persistFlag(enabled: boolean): void {
  try {
    localStorage.setItem(FLAG_KEY, String(enabled))
  } catch {
    // localStorage indisponível (modo privado etc.): a flag vale só para esta navegação.
  }
}

/** `search` é `location.search`; `?ff=finance-core` liga a flag de vez. */
export function isFinanceCoreUiEnabled(search = ''): boolean {
  if (new URLSearchParams(search).get(FINANCE_CORE_FLAG.param) === FINANCE_CORE_FLAG.value) {
    persistFlag(true)
    return true
  }
  return readStoredFlag()
}
